export const AppString = {
  ID: 'id',
  PHOTO_URL: 'photoUrl',
  NICKNAME: 'nickname',
  ABOUT_ME: 'aboutMe',
  NODE_MESSAGES: 'messages',
  NODE_USERS: 'users',
  UPLOAD_CHANGED: 'state_changed',
  DOC_ADDED: 'added',
  PREFIX_IMAGE: 'image/',

  ANONYMOUS_ID: 'anonymous',
  ANONYMOUS_DISPLAY_NAME: 'Anonymous',
  ANONYMOUS_PHOTO_URL: 'https://raw.githubusercontent.com/duytq94/reactjs-chat-demo/build-electron/src/images/ic-anonymous.png',
  ANONYMOUS_ABOUTE_ME: 'A user with login anonymous mode'
}
